import { render } from "./Confirmation.vue?vue&type=template&id=b07f77ba"
import script from "./Confirmation.vue?vue&type=script&lang=js"
export * from "./Confirmation.vue?vue&type=script&lang=js"
script.render = render

export default script